
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'

import { mapActions } from 'vuex'
export default {
name: 'info',
props: [],
components: {
Group,
Cell,
PopupPicker,
XInput,
XTextarea
},
data () {
return {
fromItem: [
{
name: '原户口省份简称',
type: 'select',
data: [[
{
id: '01',
value: '陕',
name: '陕'
},
{
id: '02',
value: '黑',
name: '黑'
},
{
id: '03',
value: '浙',
name: '浙'
},
{
id: '04',
value: '京',
name: '京'
}
]],
value: []
},
{
name: '编号',
type: 'text',
max: '',
readonly: false,
value: ''
},
{
name: '迁移证号',
type: 'text',
readonly: true,
max: '',
value: ''
}
],
addressInfo: [
{
name: '原户口省份简称',
label: '原户口省份简称',
value2: [],
value: ''
},
{
name: '编号',
label: '编号',
value: ''
},
{
name: '迁移证号',
label: '迁移证号',
value: ''
}
]
}
},
computed: {},
created () {},
mounted () {
this.addressInfo = this.$store.state.addressInfo
},
methods: {
...mapActions(['addressInfoAction']),
onBlur () {
this.addressInfo.forEach(element => {
if (typeof element.value2 === 'object') {
element.value = element.value2[0]
}
})
this.addressInfo[2].value = this.addressInfo[0].value + this.addressInfo[1].value
this.$store.dispatch('addressInfoAction', this.addressInfo)
},
onShow () {
},
onHide (closeType) {

if (closeType === true) {
this.onBlur()
}
}
}
}



// WEBPACK FOOTER //
// ./src/yingxin/tskjxy/views/items/address/info.vue